import * as React from 'react';
import {
    IntegrationParameterT,
    IntegrationParameterTypeT,
} from 'routes/IntegrationsList/types';
import '../_cellar.scss';
import ParameterVariantInput from './ParameterVariantInput';
import ParameterStringInput from './ParameterStringInput';
import ParameterNumberInput from './ParameterNumberInput';
import ParameterBooleanInput from './ParameterBooleanInput';
import ParameterListInput from './ParameterListInput';

type Props = {
    parameterName: string;
    parameterType: IntegrationParameterTypeT;
    value: IntegrationParameterT;
    setParameterValue: FlowAnyFunction;
};

const ParameterInput = ({
    parameterName,
    parameterType,
    value,
    setParameterValue,
}: Props): React.ReactElement => {
    if (Array.isArray(parameterType)) {
        return (
            <ParameterVariantInput
                value={value}
                possibleValues={parameterType}
                setParameterValue={setParameterValue}
                parameterName={parameterName}
            />
        );
    }

    switch (parameterType) {
        case 'str':
        case 'date_str':
            return (
                <ParameterStringInput
                    value={value}
                    setParameterValue={setParameterValue}
                    parameterName={parameterName}
                />
            );
        case 'number':
            return (
                <ParameterNumberInput
                    value={value}
                    setParameterValue={setParameterValue}
                    parameterName={parameterName}
                />
            );
        case 'list[number]':
        case 'list[str]':
        case 'list[bool]':
            return (
                <ParameterListInput
                    value={value}
                    setParameterValue={setParameterValue}
                    parameterName={parameterName}
                    parameterType={parameterType}
                />
            );
        case 'bool':
            return (
                <ParameterBooleanInput
                    value={value}
                    setParameterValue={setParameterValue}
                    parameterName={parameterName}
                />
            );
        default:
            return (
                <ParameterStringInput
                    value={value}
                    setParameterValue={setParameterValue}
                    parameterName={parameterName}
                />
            );
    }
};

export default ParameterInput;
